module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-controls"
  }, [_c('div', {
    staticClass: "control is-large is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    ref: "inputcoin",
    staticClass: "input is-large",
    attrs: {
      "id": "local-coin-search",
      "type": "text",
      "placeholder": "Search for your coin / token",
      "tabindex": "1",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "click": _vm.focusFirst,
      "keyup": _vm.focusFirst,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.clickFirst.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "filter-type is-flex has-text-centered"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_vm._m(0), _vm._l((_vm.coinTags), function(o) {
    return _c('div', {
      staticClass: "tag",
      class: {
        'selected': o.selected,
        'new': o.code == 'new'
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(o)
        }
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)]), (_vm.isLoading) ? _c('div', {
    staticClass: "mt-20 mb-20 has-text-centered"
  }, [_vm._v("Loading coins...")]) : _vm._e()]), (!_vm.isLoading) ? _c('div', {
    staticClass: "categories",
    style: (_vm.maxHeightContainer > 0 ? 'max-height: ' + _vm.maxHeightContainer + 'px' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTopShadow),
      expression: "showTopShadow"
    }],
    staticClass: "box-shadow-container top box-shadow-container-top"
  }), _c('div', {
    staticClass: "categories-container",
    style: (_vm.maxHeightContainer > 0 ? 'max-height: ' + _vm.maxHeightContainer + 'px' : ''),
    attrs: {
      "id": _vm.id
    }
  }, [_vm._l((_vm.filteredList.coins), function(c, index) {
    return (c.list.length > 0) ? [_c('div', {
      staticClass: "category-title text-white-on-dark",
      on: {
        "click": function($event) {
          return _vm.toggleSection(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_vm._v(_vm._s(c.category) + " ")]), _c('span', {
      staticClass: "count"
    }, [_vm._v("(" + _vm._s(c.list.length) + ")")])]), _c('div', {
      staticClass: "caret"
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-caret-up': _vm.toggleCategories[index],
        'fa-caret-down': !_vm.toggleCategories[index]
      }
    })])]), (_vm.toggleCategories[index]) ? _c('div', {
      staticClass: "columns is-multiline is-mobile"
    }, _vm._l((c.list), function(o, idx) {
      return _c('div', {
        staticClass: "column coin-selector-column is-one-third-tablet is-one-fifth-desktop is-one-third-widescreen is-one-fifth-fullhd is-half-mobile"
      }, [_c('div', {
        staticClass: "info-miner w100 bottom-10 coin-selector",
        class: {
          'is-loading': _vm.isLoadingCoin[o.symbol]
        },
        attrs: {
          "href": "#",
          "tabindex": "2"
        },
        on: {
          "click": function($event) {
            return _vm.selectCoin(o)
          },
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.selectCoin(o)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
            return _vm.removeOtherFocus()
          }],
          "mouseover": function($event) {
            return _vm.removeOtherFocus()
          }
        }
      }, [_c('div', {
        staticClass: "img-container"
      }, [_c('div', {
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": o.logo,
          "alt": o.symbol + ' icon'
        }
      }), (o.top === 1) ? _c('div', {
        staticClass: "new-tag"
      }, [_vm._v("New")]) : (o.delisted === 1) ? _c('div', {
        staticClass: "new-tag delisted"
      }, [_vm._v("Delisted")]) : _vm._e(), (_vm.isLoadingCoin[o.symbol]) ? _c('div', {
        staticClass: "coin-loading"
      }, [_c('i', {
        staticClass: "fa fa-circle-o-notch fa-spin"
      })]) : _vm._e()])]), _c('p', [_c('b', [_vm._v(_vm._s(o.name))])]), _c('p', [_c('span', [_vm._v(_vm._s(o.symbol))])])])])
    }), 0) : _vm._e()] : _vm._e()
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBottomShadow),
      expression: "showBottomShadow"
    }],
    staticClass: "box-shadow-container bottom box-shadow-container-bottom"
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title-tag"
  }, [_c('span', [_vm._v("Filter ")]), _c('span', {
    staticClass: "filter-extra-text"
  }, [_vm._v("by tags")]), _c('span', [_vm._v(": ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec6eaeb4","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_coin_list.vue
// module id = 394
// module chunks = 1